import { classNames } from '@vkontakte/vkui';
import { DeviceType } from '../../types';
import styles from './BaseTitleImage.module.css';

export interface BaseTitleImageProps<T extends string> extends React.SVGProps<SVGSVGElement> {
  type: T;
  assets: Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>>>;
  defaultSizes?: Record<string, Record<string, { width: number; height: number }>>;
  asideSrc?: string;
  deviceType?: DeviceType;
  className?: string;
}

export function BaseTitleImage<T extends string>(props: BaseTitleImageProps<T>) {
  const { type, assets, defaultSizes, asideSrc, deviceType = 'mobile', className, ...rest } = props;
  const key = `${type}_${deviceType}`;
  const IconComponent = key in assets ? assets[key] : assets[type];

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!IconComponent) {
    return null;
  }

  const size = defaultSizes?.[type]?.[deviceType];

  return (
    <div
      className={classNames(styles.root, styles[`root__${deviceType}`], className)}
      style={size ? { width: size.width, height: size.height } : void 0}
    >
      {asideSrc && <img src={asideSrc} alt="" className={styles.aside} />}
      <IconComponent className={styles.icon} {...rest} />
    </div>
  );
}
